import React from 'react';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import Select from 'react-select';
import { MdEdit } from "react-icons/md";
import { FaPlus, FaClipboard, FaLayerGroup } from "react-icons/fa";

import LeadConst from '../../util/LeadConst';
import './LeadPreview.css';
import withRouter from './../../util/WithRouter';

class LeadPreviewActionList extends React.Component {

  customStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 1000,
    }),
  };

  static TypeActive = 1;
  static TypeAll = 2;
  onActionClick = option => this.props.showPopUp(null, option.action);
  onProperties = () => {
    const lead = this.props.lead;
    const filter = [];

    if (lead.min_budget && lead.max_budget) filter.push({
      field: 'price', type: 'decimal',
      condition: 'in', value: `${lead.min_budget}~${lead.max_budget}`
    });
    else if (lead.min_budget) filter.push({
      field: 'price', type: 'decimal',
      condition: 'start-with', value: `${lead.min_budget}~`
    });
    else if (lead.max_budget) filter.push({
      field: 'price', type: 'decimal',
      condition: 'end-with', value: `~${lead.max_budget}`
    });

    if (lead.property_transaction) filter.push({
      field: 'property_transaction', type: 'select',
      condition: 'in', value: `${lead.property_transaction}`
    });

    if (lead.property_is) filter.push({
      field: 'property_is', type: 'select',
      condition: 'in', value: `${lead.property_is}`
    });

    if (lead.property_type) filter.push({
      field: 'property_type', type: 'select',
      condition: 'in', value: `${lead.property_type}`
    });
    if (lead.area) filter.push({
      field: 'area', type: 'select',
      condition: 'in', value: `${lead.area}`
    });
    this.props.navigate(`/property?filters=${JSON.stringify(filter)}`);
  };
  render() {
    const props = { ...this.props };

    const actions = [{ label: 'WhatsApp', action: LeadConst.WhatsApp }];
    if (props.NoteAdd) { actions.push({ label: props.models.note.model_name, action: LeadConst.Note }); }
    if (props.EmailAdd) { actions.push({ label: props.models.email.model_name, action: LeadConst.Email }); }
    if (props.DocAdd) { actions.push({ label: props.models.document.model_name, action: LeadConst.Document }); }
    if (props.SmsAdd) { actions.push({ label: props.models.sms.model_name, action: LeadConst.SMS }); }
    if (props.SalesAdd) { actions.push({ label: props.models.sales_order.model_name, action: LeadConst.SalesOrder }); }
    if (props.QuoteAdd) { actions.push({ label: props.models.quote.model_name, action: LeadConst.Quote }); }
    if (props.ContactAdd) { actions.push({ label: props.models.contact.model_name, action: LeadConst.Contact }); }
    if (props.Delete) { actions.push({ label: 'Delete', action: LeadConst.Delete }); }
    actions.push({ label: 'History', action: LeadConst.History });
    return (
      <div className="menubtnlead-div">
        <span className="action-btns-lg">
          <span className="btnspnsp">
            {props.iItem > 1 ? <span className="prevbtnl btnnp" onClick={props.onPrev}><IoIosArrowBack /></span> : null}
            {props.iItem < props.lItem ? <span className="nextbtnl btnnp" onClick={props.onNext}><IoIosArrowForward /></span> : null}
          </span>
          {props.CallAdd ? <span className="buttons call" variant="primary"
            onClick={() => props.showPopUp(null, LeadConst.Call)}><FaPlus /> {props.models.call.model_name}</span> : null}
          {props.MeetAdd ? <span className="buttons meeting" variant="primary"
            onClick={() => props.showPopUp(null, LeadConst.Meeting)}><FaPlus /> {props.models.meeting.model_name}</span> : null}
          {props.Property ? (<span className="buttons fmt" variant="primary" onClick={this.onProperties}><FaLayerGroup />Properties</span>) : null}
          {props.Update ? (<span className="buttons sales" variant="primary" onClick={() => props.showPopUp(null, LeadConst.Edit)}><MdEdit />Edit</span>) : null}
          {props.NoteAdd ? (<span className="buttons note" variant="primary" onClick={() => props.showPopUp({}, LeadConst.Note)}>
            <FaClipboard /> {props.models.note.model_name}
          </span>
          ) : null}
          {props.CloudCall ? (<span className="buttons delete" variant="primary" onClick={() => props.showPopUp(null, LeadConst.CloudCall)}>
            Cloud Call
          </span>
          ) : null}
          {props.type === LeadPreviewActionList.TypeActive || true ? <span className="slectbtn">
            <Select value="" onChange={this.onActionClick} options={actions} placeholder="Select Action" /> </span> : null}

          <span className="slectbtn">
            <Select styles={this.customStyles} value={this.props.option} defaultValue={3} onChange={this.props.onDesignChange} options={this.props.options} />
          </span>
        </span>
      </div>
    );
  }
}
export default withRouter(LeadPreviewActionList);
